lmApp
  .controller('ImportController', ['$scope', '$rootScope', '$timeout', '$interval', 'ToastService', 'ImportService', 'ModalWindowService',
    function ($scope, $rootScope, $timeout, $interval, ToastService, ImportService, ModalWindowService) {

      $scope.loading = false;
      $scope.taskState = 'all';
      $scope.byDate = {
        from: moment.utc().startOf('month'),
        to: moment.utc().endOf('month')
      };

      $scope.editorOptions = {
        lineNumbers: true,
        indentWithTabs: true,
        mode: 'html'
      };

      var parseTaskStatus = function (status) {
        var state = {};

        switch (status) {
          case 'finished':
            state.title = status.toUpperCase();
            state.color = 'green';
            break;
          case 'failed':
            state.title = status.toUpperCase();
            state.color = 'red';
            break;
          case 'canceled':
            state.title = status.toUpperCase() + ' BY USER';
            state.color = 'red';
            break;
          case 'process':
            state.title = 'IN PROGRESS';
            state.color = 'yellow';
            break;
          case 'preprocess':
            state.title = 'IN PROGRESS';
            state.color = 'yellow';
            break;
          case 'pending':
            state.title = status.toUpperCase();
            state.color = 'yellow';
            break;
          default:
            state.title = status.toUpperCase();
            state.color = 'black';
        }

        return state;
      };

      var parseNodeStatus = function (node) {
        var state = {};

        switch (node.state) {
          case 'finished':
            state.title = node.state.toUpperCase();
            state.color = 'green';
            state.icon = 'checkbox-marked-circle-outline';
            break;
          case 'failed':
            state.title = node.state.toUpperCase();
            state.color = 'red';
            state.icon = 'close-circle-outline';
            break;
          case 'process':
            state.title = 'IN PROGRESS';
            state.color = 'yellow';
            state.icon = 'checkbox-blank-circle-outline';
            break;
          case 'deploy_resources':
            state.title = 'Deploy Resources'.toUpperCase();
            state.color = 'yellow';
            state.icon = 'play-circle-outline';
            break;
          case 'pending':
            state.title = node.state.toUpperCase();
            state.color = 'black';
            state.icon = 'pause-circle-outline';
            break;
          default:
            state.title = node.state.toUpperCase();
            state.color = 'black';
            state.icon = 'checkbox-blank-circle-outline';
        }

        if (node.warnings && !_.isEmpty(node.warnings) && !node.error) {
          state.color = 'amber';
          state.icon = 'alert-circle';
          state.title = 'NEED ATTENTION'.toUpperCase();
        }

        return state;
      };

      var parseTask = function (task, isActive) {
        task._PrivateData = {};

        task._PrivateData.expand = !!isActive;
        task._PrivateData.warningFilter = false;
        task._PrivateData.errorFilter = false;
        task._PrivateData._Items = [];

        if (task.failed_items_count <= 9 && task.failed_items_count > 0) {
          task._PrivateData.errorCount = task.failed_items_count;
        } else if (task.failed_items_count > 9) {
          task._PrivateData.errorCount = '9-plus';
        } else {
          task._PrivateData.errorCount = 'null';
        }

        if (task.warnings_items_count < 9 && task.warnings_items_count > 0) {
          task._PrivateData.warningCount = task.warnings_items_count;
        } else if (task.warnings_items_count > 9) {
          task._PrivateData.warningCount = '9-plus'
        } else {
          task._PrivateData.warningCount = 'null';
        }

        task._PrivateData.state = parseTaskStatus(task.state);

        if (task.start_time) {
          task._PrivateData.create_time = moment.utc(task.start_time * 1000);
        } else {
          task._PrivateData.create_time = moment.utc();
        }

        if (task.last_update_time) {
          task._PrivateData.finish_time = moment.utc(task.last_update_time * 1000);
        } else {
          task._PrivateData.finish_time = moment.utc();
        }

        return task;
      };

      var parseNode = function (item, isActive) {
        item._PrivateData = {};
        item._PrivateData.isActive = !!isActive;
        item._PrivateData.state = parseNodeStatus(item);

        item._PrivateData.actions = _.isArray(item.actions) ? '' : angular.uppercase(item.actions);

        return item;
      };

      var getEditorHeight = function (node) {
        angular.element("#ace" + node.id).css({height: angular.element("#textarea" + node.id).val().split("\n").length + angular.element("#textarea" + node.id).val().split("\n").length * 0.1 + 'rem'});
      };

      $scope.collection = [];

      $scope.applyTaskFilter = function () {
        return function (task) {
          return ($scope.taskState === 'all')
            || ($scope.taskState === 'active' && (task.state === 'process' || task.state === 'preprocess'))
            || ($scope.taskState === 'completed' && task.state === 'finished')
            || ($scope.taskState === 'date' && task.start_time >= $scope.byDate.from.startOf('day').unix() && task.start_time <= $scope.byDate.to.endOf('day').unix())
            || ($scope.taskState === 'failed' && task.state === 'failed');
        };
      };

      $scope.applyNodeFilter = function (task) {
        return function (node) {
          return (!task._PrivateData.errorFilter && !task._PrivateData.warningFilter)
            || (task._PrivateData.errorFilter && node.error)
            || (task._PrivateData.warningFilter && node.warnings);
        };
      };

      $scope.uploadXml = function () {
        if ($scope.loading) return;

        $timeout(function () {
          angular.element('#import_xml').trigger('click');
        });
      };

      $scope.cancelImportTask = function (task) {
        ModalWindowService.Open({
          content: '<p class="fs-headline tc-red-800"> Cancel import task </p> <p class="fs-title">This action will cancel import task permanently. ' +
          'Are You sure? </p>',
          actions: [
            {
              title: 'Do it',
              icon: 'close-box-outline',
              color: 'red',
              fn: function () {
                $scope.loading = true;
                $rootScope.showLinearProgress('#taskLoader' + task.id);

                ImportService.CancelImport(task)
                  .then(function (response) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#taskLoader' + task.id);
                    ToastService.Small({
                      title: 'Task successfully canceled',
                      color: 'green',
                      icon: 'close-box-outline'
                    }, 1000 * 3);
                    $scope.getTasks({id: 'all'});
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#taskLoader' + task.id);
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Task cancel failed',
                      color: 'red',
                      icon: 'close-box-outline'
                    }, 1000 * 3);
                  });
              }
            },
            {
              title: 'Cancel'
            }
          ]
        });
      };

      $scope.getTasks = function (who) {
        if (who.id === 'all') {
          $scope.loading = true;
          $rootScope.showLinearProgress('#importLoader');

          ImportService.GetImportTasks()
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#importLoader');
              $scope.collection = collection.map(function (task) {
                return parseTask(task);
              });
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#importLoader');
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            });
        }

        if (_.isFinite(who.id)) {
          $scope.loading = true;
          $rootScope.showLinearProgress('#importLoader');

          ImportService.GetImportTaskById([who.id])
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#importLoader');
              if (collection.length) {
                who.collection[who.index] = parseTask(collection[0], who.active);
                $scope.getNodes(collection[0], {id: 'all'});
              } else {
                who.collection.splice(who.index, 1);
              }
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#importLoader');
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            });
        }
      };

      $scope.getNodes = function (task, who) {
        if (who.id === 'all') {
          ImportService.GetTaskItems(task)
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#taskLoader' + task.id);
              task._PrivateData.expand = true;
              task._PrivateData._Items = collection.map(function (item) {
                return parseNode(item);
              })
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#taskLoader' + task.id);
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            })
        }

        if (_.isFinite(who.id)) {
          ImportService.GetTaskItemsById([who.id])
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#taskLoader' + task.id);
              task._PrivateData._Items[who.index] = parseNode(collection[0], who.active);
              $scope.getNodeXml(task, collection[0]);
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#taskLoader' + task.id);
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            })
        }

      };

      $scope.toggleItems = function (task) {
        if (task._PrivateData.expand) {
          task._PrivateData.expand = false;
        } else {
          $scope.loading = true;
          $rootScope.showLinearProgress('#taskLoader' + task.id);


          $scope.getNodes(task, {id: 'all'});
        }
      };

      $scope.getNodeXml = function (task, node) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#taskLoader' + task.id);

        ImportService.GetNodeXml(node)
          .then(function (xml) {
            node._PrivateData.xml = xml[0];
            node._PrivateData.xmlOrigin = xml[0];
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });
      };


      $scope.toggleNodeXml = function (task, node) {
        if (node._PrivateData.isActive) {
          node._PrivateData.isActive = false;
        } else {
          node._PrivateData.isActive = true;

          $scope.getNodeXml(task, node);
        }
      };

      $scope.saveXML = function (task, node) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#taskLoader' + task.id);

        ImportService.SaveNodeXml(node, node._PrivateData.xml)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            ToastService.Small({
              title: 'Changes successfully saved',
              color: 'green',
              icon: 'xml'
            }, 1000 * 3);
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Save failed',
              color: 'red',
              icon: 'xml'
            }, 1000 * 3);
          });
      };

      $scope.resetXML = function (node) {
        node._PrivateData.xml = node._PrivateData.xmlOrigin;
      };

      $scope.restartImport = function (task) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#taskLoader' + task.id);

        var _ids = task._PrivateData._Items.map(function (item) {
          return item.id;
        });

        ImportService.RestartNodes(task, _ids)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            ToastService.Small({
              title: 'Task successfully restarted',
              color: 'green',
              icon: 'refresh'
            }, 1000 * 3);
            $scope.getTasks({id: 'all'});
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Task restart failed',
              color: 'red',
              icon: 'refresh'
            }, 1000 * 3);
          });
      };

      $scope.restartThread = function (task, item, index) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#taskLoader' + task.id);

        ImportService.RestartNodes(task, [item.id])
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            ToastService.Small({
              title: 'Thread successfully restarted',
              color: 'green',
              icon: 'refresh'
            }, 1000 * 3);
            $scope.getNodes(task, {id: item.id, index: index, active: true});
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#taskLoader' + task.id);
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Thread restart failed',
              color: 'red',
              icon: 'refresh'
            }, 1000 * 3);
          });
      };

      $scope.deleteImport = function (task) {
        ModalWindowService.Open({
          content: '<p class="fs-headline tc-red-800"> DELETE IMPORT TASK </p> <p class="fs-title">This action will delete import task permanently. All imported data will be save.' +
          'Are You sure? </p>',
          actions: [
            {
              title: 'Yes',
              icon: 'delete',
              color: 'red',
              fn: function () {
                $scope.loading = true;
                $rootScope.showLinearProgress('#taskLoader' + task.id);

                ImportService.DeleteImport(task)
                  .then(function (response) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#taskLoader' + task.id);
                    ToastService.Small({
                      title: 'Task successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    }, 1000 * 3);
                    $scope.getTasks({id: 'all'});
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#taskLoader' + task.id);
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Task delete failed',
                      color: 'red',
                      icon: 'delete'
                    }, 1000 * 3);
                  });
              }
            },
            {
              title: 'Cancel'
            }
          ]
        });
      };

      $scope.getTasks({id: 'all'});

      $scope.int = $interval(function () {
        $scope.getTasks({id: 'all'});
      }, 15 * 60 * 1000);

      $timeout(function () {
        angular.element('#import_xml')
          .on('change', function () {
            $scope._progress_ = angular.element('#importProgress');
            $scope._bar_ = $scope._progress_.find('.determinate');

            $scope.error = '';
            if (!this.files || !this.files.length) {
              ToastService.Small({
                title: 'Please, choose at least one file',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            var file = this.files[0];

            if (file.type !== 'text/xml') {
              ToastService.Small({
                title: 'File should be in XML format',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            $scope.loading = true;
            $scope._progress_.css({'display': 'block'});

            angular.element('#import_xml').innerHTML =  angular.element('#import_xml').innerHTML;

            ImportService.UploadToCloud(file, angular.element('#importProgress'))
              .then(function (response) {
                $scope._progress_.css({'display': 'none'});
                $scope._bar_.css({width: 0});
                ImportService.CreateNewImport(response.Location)
                  .then(function () {
                    $scope.loading = false;
                    $scope.getTasks({id: 'all'});
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                  });
              }, function (reason) {
                $scope.loading = false;
                $scope._progress_.css({'display': 'none'});
                $scope._bar_.css({width: 0});
                $rootScope.debugInfo(reason);
              });
          });
      }, 600);

      $scope.$on('$destroy', function () {
        $interval.cancel($scope.int);

        angular.element('#import_xml').off('change');
      })
    }]);
